import React, { useState, useEffect } from "react";
import styles from './VerPaso.module.css';
import imageDef from "./images/MIS_INTERESESFT.png";
import ImgIl from "./Secciones/images/IMAGEN.png";
import AniadirSeccion from "./Secciones/AniadirSeccion";
import {
    FaArrowLeft, FaMedapps, FaPlusCircle, FaTrash, FaEdit, FaEye, FaSadCry, FaSave, FaUndo,
    FaBrain,
    FaMagic,
    FaRocket,
    FaDog,
    FaCat,
    FaBook,
    FaMusic,
    FaPuzzlePiece
} from 'react-icons/fa';
import {IoMdTrash, IoMdCreate} from 'react-icons/io'; 
import Swal from 'sweetalert2';
import NuevaSeccion from "./Secciones/NuevaSeccion";
import VerSeccion from "./Secciones/VerSeccion";
import EditarSeccion from "./Secciones/EditarSeccion";
import PasoTest from "./PasoTest";
import {useAuth} from '../../Auth/AuthContext'; 

const iconMap = {
    FaTrash: FaTrash,
    FaEdit: FaEdit,
    FaEye: FaEye,
    FaSadCry: FaSadCry,
    FaBrain: FaBrain,
    FaMagic: FaMagic,
    FaRocket: FaRocket,
    FaDog: FaDog,
    FaCat: FaCat,
    FaBook: FaBook,
    FaMusic: FaMusic,
    FaPuzzlePiece: FaPuzzlePiece,
};

const VerPaso = ({ paso, onBack }) => {
    const [pasoElementos, setPasoElementos] = useState([]);
    const [originalElementosOrder, setOriginalElementosOrder] = useState([]);
    const [error, setError] = useState(null);
    const [modalSeccion, setModalSeccion] = useState(false);
    const [modalTest, setModalTest] = useState(false);
    const {getToken} = useAuth(); 
    const token = getToken(); 
    const [creatingSection, setCreatingSection] = useState(null);
    const [creatingTest, setCreatingTest] = useState(null);
    const [mostrarModalSeccion, setMostrarModalSeccion] = useState(false);
    const [mostrarModalTest, setMostrarModalTest] = useState(false);
    const [currentView, setCurrentView] = useState('list'); 
    const [editingSeccionId, setEditingSeccionId] = useState(null);
    const [viewingSeccion, setViewingSeccion] = useState(null);
    const [viewingTest, setViewingTest] = useState(null);
    const [isDragging, setIsDragging] = useState(false);
    const [draggedItem, setDraggedItem] = useState(null);
    const [hasChanges, setHasChanges] = useState(false);

    const deepCopyElements = (elements) => {
        return elements.map(element => ({ 
            ...element
        }));
    };

    // Funciones de drag and drop
    const handleItemDragStart = (e, item, index) => {
        setIsDragging(true);
        setDraggedItem({ item, index });
        e.dataTransfer.effectAllowed = 'move';
        e.target.style.opacity = '0.5';
    };

    const handleItemDragEnd = (e) => {
        setIsDragging(false);
        setDraggedItem(null);
        e.target.style.opacity = '1';

        // Remover todas las clases de drop
        document.querySelectorAll('.drag-over-item').forEach(el => {
            el.classList.remove('drag-over-item');
        });
    };

    const handleItemDragOver = (e) => {
        e.preventDefault();
        e.dataTransfer.dropEffect = 'move';
    };

    const handleItemDragEnter = (e, index) => {
        e.preventDefault();
        if (draggedItem && draggedItem.index !== index) {
            e.currentTarget.classList.add('drag-over-item');
        }
    };

    const handleItemDragLeave = (e) => {
        e.currentTarget.classList.remove('drag-over-item');
    };

    const handleItemDrop = (e, targetIndex) => {
        e.preventDefault();
        e.currentTarget.classList.remove('drag-over-item');

        if (!draggedItem || draggedItem.index === targetIndex) {
            return;
        }

        const newElements = [...pasoElementos];
        const draggedItemData = newElements[draggedItem.index];

        // Remover el elemento de su posición original
        newElements.splice(draggedItem.index, 1);
        
        // Insertarlo en la nueva posición
        newElements.splice(targetIndex, 0, draggedItemData);

        // Actualizar los números de orden
        const updatedElements = newElements.map((element, index) => ({
            ...element,
            pael_orden: index + 1
        }));

        setPasoElementos(updatedElements);
        setHasChanges(true);
    };

    // Guardar nuevo orden
    const handleSaveOrder = async () => {
        try {
            const nuevoOrden = pasoElementos.map((element, index) => ({
                pael_clave: element.pael_clave,
                pael_orden: index + 1
            }));

            const response = await fetch(`${process.env.REACT_APP_API_URL}/pasos/reorder-elementos`, {
                method: 'PUT',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    paso_id: paso.pa_clave,
                    nuevo_orden: nuevoOrden
                })
            });

            const data = await response.json();

            if (data.success) {
                setOriginalElementosOrder([...pasoElementos]);
                setHasChanges(false);
                Swal.fire({
                    title: 'Orden guardado correctamente', 
                    icon: 'success', 
                    timer: 1000,
                    showConfirmButton: false, 
                    customClass: { 
                        popup: 'popupbonito', 
                    },
                })
            } else {
                Swal.fire({
                    title: 'Error al guardar orden', 
                    icon: 'error', 
                    confirmButtonText: 'Entendido', 
                    confirmButtonColor: '#242b57', 
                    customClass: { 
                        popup: 'popupbonito', 
                    },
                })
            }
        } catch (error) {
            console.error('Error:', error);
            alert('Error de conexión');
        }
    };

    // Restaurar orden original
    const handleRestoreOrder = () => {
        if (originalElementosOrder.length > 0) {
            const restoredOrder = deepCopyElements(originalElementosOrder);
            setPasoElementos(restoredOrder);
            setHasChanges(false);
        } else {
            console.warn('No hay orden original guardado');
            fetchData();
        }
    };

    useEffect(() => {
        if (paso.pa_clave) {
            fetchData();
        }
    }, [paso.pa_clave]);

    // Función para obtener elementos del paso
    const fetchData = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/pasos/paso-elementos/${paso.pa_clave}`, {
                headers: { 
                        'Authorization':  `Bearer ${token}`
                }
            });

            if (response.ok) {
                const data = await response.json();
                setPasoElementos(data);
                
                // Guardar orden original solo si no hay cambios pendientes
                if (!hasChanges) {
                    setTimeout(() => {
                        setOriginalElementosOrder(deepCopyElements(data));
                    }, 0);
                }
            } else if (response.status === 404) {
                setPasoElementos([]);
                setOriginalElementosOrder([]);
            } else {
                throw new Error('Error al obtener los elementos');
            }
        } catch (err) {
            setError(err.message);
            setPasoElementos([]);
        }
    };

    //CRUD secciones
    const handleCrearSeccion = (datosSeccion) => {
        setCreatingSection(datosSeccion);
        setMostrarModalSeccion(false);
    };

    const handleVolverDeSeccion = () => {
        setCreatingSection(null);
    };

    const handleSeccionCreada = () => {
        fetchData();
        setCreatingSection(null);
    };

    // Si estamos creando una sección, mostrar esa página
    if (creatingSection) {
        return (
            <NuevaSeccion
                pasoId={creatingSection.pasoId}
                tipoArchivo={creatingSection.tipoArchivo}
                plantillaId={creatingSection.plantillaId}
                plantillaNombre={creatingSection.plantillaNombre}
                onVolver={handleVolverDeSeccion}
                onGuardar={handleSeccionCreada}
            />
        );
    }

    const handleEdit = (seccionId) => {
        setEditingSeccionId(seccionId);
        setCurrentView('edit');
        window.scrollTo(0, 0);
    };

    const handleBackToList = () => {
        setCurrentView('list');
        setEditingSeccionId(null);
        setViewingSeccion(null);
        setViewingTest(null);
        window.scrollTo(0, 0);
    };

    const handleSeccionUpdated = () => {
        fetchData();
    };

    const handleDelete = async (elemento) => {
        const isSeccion = elemento.tipo === 'seccion';
        
        const confirmDelete = await Swal.fire({
            title: `¿Eliminar ${isSeccion ? 'sección' : 'test'}?`,
            text: isSeccion 
                ? 'Esta acción eliminará la sección completamente del sistema y afectará a todos los usuarios que tengan progreso en ella. No se puede deshacer.' 
                : 'Eliminarás el test del paso. Podrás ver el test únicamente en el apartado de Test.',
            icon: 'warning',
            confirmButtonText: 'Eliminar',
            confirmButtonColor: '#242b57',
            cancelButtonColor: '#242b57',
            customClass: {
                popup: 'popupbonito',
            },
        });

        if (!confirmDelete.isConfirmed) return;
        
        try {
            let response;
            if (isSeccion) {
                response = await fetch(`${process.env.REACT_APP_API_URL}/pasos/eliminar-seccion/${elemento.id}`, {
                    method: 'DELETE',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                    }
                });
            } else {
                response = await fetch(`${process.env.REACT_APP_API_URL}/pasos/eliminar-test/${paso.pa_clave}`, {
                    method: 'DELETE',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        testId: elemento.id
                    })
                });
            }

            if (!response.ok) {
                throw new Error(`Error: ${response.status}`);
            }

            const data = await response.json();
            await fetchData();

            if (isSeccion && data.detalles) {
                const { detalles, advertencia, pasos_modificados } = data;
                
                let htmlContent = `
                    <div style="text-align: center; font-size: 20px;">                    
                        ${detalles.progreso_usuarios_eliminado.usuarios_afectados > 0 ? `
                                <strong>Usuarios afectados:</strong> ${detalles.progreso_usuarios_eliminado.usuarios_afectados}
                        ` : '<p> No había usuarios con progreso en esta sección</p>'}
                        ${pasos_modificados?.llenados_con_seccion_basica?.length > 0 ? `
                            <p style="color: #339af0;">
                                <strong>Pasos completados automáticamente:</strong> ${pasos_modificados.llenados_con_seccion_basica.length}
                                <br><small>Se agregó contenido básico a pasos que quedaron vacíos</small>
                            </p>
                        ` : ''}
                    </div>
                `;

                await Swal.fire({
                    title: 'Sección Eliminada Completamente',
                    html: htmlContent,
                    icon: advertencia ? 'warning' : 'success',
                    confirmButtonText: 'Entendido',
                    confirmButtonColor: '#242b57',
                    width: '500px',
                    customClass: {
                        popup: 'popupbonito',
                    },
                });

                if (advertencia) {
                    await Swal.fire({
                        title: 'Importante',
                        text: advertencia,
                        icon: 'info',
                        confirmButtonText: 'Entendido',
                        confirmButtonColor: '#242b57',
                        customClass: {
                            popup: 'popupbonito',
                        },
                    });
                }

            } else {
                Swal.fire({
                    title: `${isSeccion ? 'Sección' : 'Test'} Eliminado`,
                    text: `${isSeccion ? 'La sección ha sido eliminada' : 'El test ha sido eliminado del paso'}`,
                    icon: 'success',
                    timer: 2000,
                    showConfirmButton: false
                });
            }

        } catch (error) {
            console.error('Error:', error);
            
            let errorMessage = `No se pudo eliminar ${isSeccion ? 'la sección' : 'el test del paso'}`;
            
            if (error.response) {
                try {
                    const errorData = await error.response.json();
                    errorMessage = errorData.error || errorMessage;
                } catch (e) {
                    console.error('Error al obtener mensaje de error:', e);
                }
            }

            Swal.fire({
                title: 'Error al Eliminar',
                text: errorMessage,
                icon: 'error',
                confirmButtonText: 'Entendido',
                confirmButtonColor: '#242b57',
                customClass: {
                    popup: 'popupbonito',
                },
            });
        }
    };

    const handleView = (elemento) => {
        if (elemento.tipo === 'seccion') {
            setViewingSeccion(elemento);
            setCurrentView('view');
        } else {
            setViewingTest(elemento);
            setCurrentView('viewT');
        }
        window.scrollTo(0, 0);
    };

    // Si estamos en vista de edición, mostrar el componente EditarSeccion
    if (currentView === 'edit') {
        return (
            <EditarSeccion
                seccionId={editingSeccionId}
                onBack={handleBackToList}
                onSeccionUpdated={handleSeccionUpdated}
            />
        );
    }
    
    // Si estamos en vista de detalles de sección
    if (currentView === 'view') {
        return (
            <VerSeccion
                seccion={viewingSeccion}
                onBack={handleBackToList}
            />
        );
    }

    //Añadir/Eliminar Test
    const handleCrearTest = (datosTest) => {
        setCreatingTest(datosTest);
        setMostrarModalTest(false);
    };

    const handleTestActualizado = () => {
        fetchData();
    };

    function formatearTamaño(bytes) {
        if (!bytes) return '0 Bytes';

        const k = 1024;
        const sizes = ['Bytes', 'KB', 'MB', 'GB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));

        return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    }

    // Función para renderizar un elemento (sección o test)
    const renderElement = (elemento, index) => {
        if (elemento.tipo === 'seccion') {
            return (
                <div
                    key={`seccion-${elemento.id}`}
                    className={`${styles.progressItemLink} ${styles.seccionCard} ${isDragging ? styles.draggableActive : ''}`}
                    draggable={true}
                    onDragStart={(e) => handleItemDragStart(e, elemento, index)}
                    onDragEnd={handleItemDragEnd}
                    onDragOver={handleItemDragOver}
                    onDragEnter={(e) => handleItemDragEnter(e, index)}
                    onDragLeave={handleItemDragLeave}
                    onDrop={(e) => handleItemDrop(e, index)}
                >
                    <div className={styles.cardActions}>
                        <button className={styles.btnView} onClick={() => handleView(elemento)} title="Ver detalles">
                            <FaEye/>
                        </button>
                        <button className={styles.btnEdit} onClick={() => handleEdit(elemento.id)} title="Editar sección">
                            <IoMdCreate />
                        </button>
                        <button className={styles.btnDelete} onClick={() => handleDelete(elemento)} title="Eliminar sección">
                            <IoMdTrash />
                        </button>
                    </div>

                    <div className={styles.progressItem}>
                    <img
    src={
        paso.pa_imagen
            ? `${process.env.REACT_APP_API_URL}/uploads/${paso.pa_imagen}`
            : imageDef
    }
    alt={paso.pa_nombre || "Imagen paso"}
    style={{
        width: '100%',
        maxWidth: '250px',
        height: '140px',
        objectFit: 'cover',
        borderRadius: '20px',
        margin: '0 auto 15px auto',
        display: 'block'
    }}
    onError={(e) => {
        e.target.onerror = null;
        e.target.src = imageDef;
    }}
/>
                        <div className={styles.progressInfo}>
                            <p>{elemento.nombre}</p>
                            {elemento.se_url && (
                                <p>
                                    Enlace:
                                    <a href={elemento.se_url} target="_blank" rel="noopener noreferrer" className={styles.urlLink}>
                                        {elemento.se_url}
                                    </a>
                                </p>
                            )}
                            {elemento.se_archivo && (
                                <p>
                                    Archivo:
                                    <a href={`/downloads/${elemento.se_archivo}`} download className={styles.fileLink}>
                                        {elemento.se_archivo}
                                    </a>
                                </p>
                            )}
                            {elemento.se_tam_archivo && (
                                <span className={styles.fileInfo}>
                                    📄 {formatearTamaño(elemento.se_tam_archivo)}
                                </span>
                            )}
                            <p>Tipo: {elemento.se_tipo_archivo}</p>
                        </div>
                    </div>
                </div>
            );
        } else if (elemento.tipo === 'test') {
            return (
                <div 
                    key={`test-${elemento.id}`}
                    className={`${styles.progressItemLink} ${styles.seccionCard} ${styles.testCard} ${isDragging ? styles.draggableActive : ''}`}
                    draggable={true}
                    onDragStart={(e) => handleItemDragStart(e, elemento, index)}
                    onDragEnd={handleItemDragEnd}
                    onDragOver={handleItemDragOver}
                    onDragEnter={(e) => handleItemDragEnter(e, index)}
                    onDragLeave={handleItemDragLeave}
                    onDrop={(e) => handleItemDrop(e, index)}
                >
                    <div className={styles.cardActions}>
                        <button className={styles.btnDelete} onClick={() => handleDelete(elemento)} title="Eliminar test">
                            <FaTrash />
                        </button>
                    </div>
                    <div className={styles.progressItem}>
                        <div className={styles.cardIcon}>
                            {iconMap[elemento.te_icon]
                                ? React.createElement(iconMap[elemento.te_icon], { className: styles.customIcon })
                                : <FaBrain className={styles.customIcon} />
                            }
                        </div>
                        <div className={styles.progressInfo}>
                            <p>{elemento.nombre}</p>
                            <p>Tipo: Test</p>
                            {elemento.te_tiempo_estimado && (
                                <p>Tiempo estimado: {elemento.te_tiempo_estimado} min</p>
                            )}
                            {elemento.te_tipo_respuesta && (
                                <p>Tipo: {elemento.te_tipo_respuesta}</p>
                            )}
                        </div>
                    </div>
                </div>
            );
        }
        return null;
    };

    if (!paso) {
        return (
        <div className={styles.loadingContainer}>
            <div className={styles.loadingContainer}> 
            <p className={styles.loadingText}> Error al cargar datos :( </p>
            </div>
        </div>
        );
    }

    return (
        <div>
            <div className={styles.vistaContainer}>
                <div className={styles.vistaHeader}>
                    <button className={styles.btnBack} onClick={onBack}>
                        <FaArrowLeft className={styles.flechaVolver} />
                        Volver a pasos
                    </button>
                    
                    <div className={styles.messageVista}>
                        <FaMedapps className={styles.messageIcon} />
                        Esto es lo que verá el usuario con la información del paso. Las plantillas editables son solo para administrador.
                    </div>
                    
                </div>

                <div className={styles.cuerpoContainer}>
                    <div className={styles.columContainer}>
                        <div className={styles.imageWrapper}>
                          <img
    src={
        paso.pa_imagen
            ? `${process.env.REACT_APP_API_URL}/uploads/${paso.pa_imagen}`
            : imageDef
    }
    alt={paso.pa_nombre || "Imagen paso"}
    style={{
        width: '100%',
        maxWidth: '250px',
        height: '140px',
        objectFit: 'cover',
        borderRadius: '20px',
        margin: '0 auto 15px auto',
        display: 'block'
    }}
    onError={(e) => {
        e.target.onerror = null;
        e.target.src = imageDef;
    }}
/>
                        </div>
                        <h2>Paso {paso.pa_numero}: {paso.pa_titulo}</h2>
                        <p>{paso.pa_descripcion}</p>

                        <div className={styles.navigationButtons}>
                            <a className={`${styles.btn} ${styles.btnVolver}`}>Regresar</a>
                            <a className={`${styles.btn} ${styles.btnContinuar}`}>Continuar</a>
                        </div>
                    </div>

                    <div className={styles.columContainerSections}>
                        <h2>{paso.pa_nom_subtitulo}</h2>
                        
                        {/* Botones para guardar/restaurar orden */}
                        {hasChanges && (
                            <div className={styles.orderButtons}>
                                <button
                                    className={styles.btnSaveOrder}
                                    onClick={handleSaveOrder}
                                    title="Guardar nuevo orden"
                                >
                                    <FaSave /> Guardar Orden
                                </button>
                                <button
                                    className={styles.btnRestoreOrder}
                                    onClick={handleRestoreOrder}
                                    title="Restaurar orden original"
                                >
                                    <FaUndo /> Restaurar
                                </button>
                            </div>
                        )}

                        {/* Lista de elementos con drag and drop */}
                        {pasoElementos.map((elemento, index) => renderElement(elemento, index))}

                        <>
                            <div onClick={() => setModalSeccion(true)} className={`${styles.progressItemLink} ${styles.addLink}`}>
                                <div className={`${styles.progressItem} ${styles.addBox}`}>
                                    <div className={styles.addIcon}><FaPlusCircle /></div>
                                    <p>Añadir nueva sección</p>
                                </div>
                            </div>

                            <AniadirSeccion
                                abrirModal={modalSeccion}
                                cerrarModal={() => setModalSeccion(false)}
                                pasoId={paso.pa_clave}
                                onCrearSeccion={handleCrearSeccion}
                            />
                        </>

                        <>
                            <div onClick={() => setModalTest(true)} className={`${styles.progressItemLink} ${styles.addLink}`}>
                                <div className={`${styles.progressItem} ${styles.addBox}`}>
                                    <div className={styles.addIcon}><FaBrain /></div>
                                    <p>Añadir nuevo test</p>
                                </div>
                            </div>

                            <PasoTest
                                abrirModal={modalTest}
                                cerrarModal={() => setModalTest(false)}
                                pasoId={paso.pa_clave}
                                onAgregarTest={handleCrearTest}
                                onTestActualizado={handleTestActualizado} 
                            />
                        </>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default VerPaso;